module.exports = __webpack_public_path__ + "img/down-triangle.ab88959e.svg";